<!--
 * @Author: your name
 * @Date: 2021-09-27 14:25:09
 * @LastEditTime: 2026-04-14 16:32:02
 * @LastEditors: YangHan 1047143112@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \kares_pad\src\components\system\ReferralCode.vue
-->
<template>
  <enfold>
    <div class="referral">
      <div class="referral-login">
        <div class="title flex-c-c">{{$t('csr1')}}</div>
        <div class="user-form" v-loading="loading" :element-loading-text="`${$t('csr2')}...`">
          <el-form :model="user" :rules="rules" ref="userForm" label-width="80px">
            <!-- 推荐申请登录 -->
            <template v-if="true">
              <el-form-item :label="$t('csr3')" prop="username">
                <el-input v-model="user.user"></el-input>
              </el-form-item>
              <el-form-item :label="$t('csr4')">
                <el-input type="password" v-model="user.pwd" auto-complete="new-password"></el-input>
              </el-form-item>
              <el-form-item label-width="50px">
                <el-button type="primary" round @click="getReferralCode">{{$t('csr5')}}</el-button>
              </el-form-item>
              <el-form-item label-width="30px" v-if="rCode != ''">
                <div class="re-login flex-d-c-c">
                  <span style="color: #1A73E8; font-size: 24px; font-weight: bold">{{rCode}}</span>
                  <span>{{$t('csr6')}}</span>
                </div>
              </el-form-item>
            </template>
            <!-- 修改密码 -->
            <template v-if="false">
              <el-form-item :label="$t('clrp9')" prop="username">
                <el-input v-model="user.npwd1" auto-complete="new-password"></el-input>
              </el-form-item>
              <el-form-item :label="$t('clrp10')">
                <el-input type="password" v-model="user.npwd2" auto-complete="new-password"></el-input>
              </el-form-item>
              <el-form-item label-width="50px">
                <el-button type="primary" round>{{$t('csr7')}}</el-button>
              </el-form-item>
              <el-form-item label-width="30px">
                <div class="re-login">
                  <span style="color: #FC011A;">{{$t('csr8')}}</span>
                </div>
              </el-form-item>
            </template>
          </el-form>
        </div>
      </div>
    </div>
  </enfold>
</template>


<script>
import enfold from '@/components/basics/Enfold'
export default {
  name: "ReferralCode",
  data() {
    return {
      user: {
        user: "",
        pwd: "",
        npwd1: "",
        npwd2: "",
      },
      rules: {},
      rCode: "",
      loading: false,
    }
  },
  methods: {
    getReferralCode() {
      this.loading = true;
      this.$http.post("/admin/signin/getReferralCode", this.user, data => {
        this.loading = false;
        this.rCode = data.referral_code;
      });
    },

    //     pwd_user: 
    // pwd_source: 
    // pwd_1: 
    // pwd_2: 
  },
  components: {
    enfold
  }
}
</script>

<style lang="scss" scoped>
.referral {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: url("../../assets/images/login/bg_logo.png") no-repeat center
    center;

  .referral-login {
    width: 400px;
    // height: 300px;
    background: #fff;
    border-radius: 8px;
    overflow: hidden;
    .title {
      height: 50px;
      font-size: 20px;
      color: #fff;
      background-image: linear-gradient(
          270deg,
          #86eae7 0%,
          #4cccf0 45%,
          #11adf8 100%
        ),
        linear-gradient(#ffffff, #ffffff);
      background-blend-mode: normal, normal;
    }
    .user-form {
      padding-right: 30px;
      padding-top: 20px;
      background-color: #fff;
      .el-form-item + .el-form-item {
        margin-top: 20px;
      }
      /deep/ .el-input-group__append {
        border-radius: 0px 20px 20px 0px;
        padding: 0 6px;
        text-align: center;
        width: 100px;
      }
      .re-login {
        text-align: center;
        line-height: 20px;
        cursor: pointer;
      }
    }
    .el-button {
      width: 100%;
      // background-image: linear-gradient(
      //     270deg,
      //     #86eae7 0%,
      //     #4cccf0 45%,
      //     #11adf8 100%
      //   ),
      //   linear-gradient(#dddddd, #dddddd);
      // background-blend-mode: normal, normal;
      // border-color: #86eae7;
      
      background-color: var(--theme-color-customized-1);
    }
    // .el-button:hover {
    //   background-image: linear-gradient(
    //       270deg,
    //       #57e4e0 0%,
    //       #2cb8de 45%,
    //       #008bdb 100%
    //     ),
    //     linear-gradient(#dddddd, #dddddd);
    //   background-blend-mode: normal, normal;
    //   border-color: #86eae7;
    // }
  }
}
</style>